import {
  IDataPreference,
  IFiltrosPainelDeVendas
} from "@/features/financas/views/Indicadores/@types/type";
import PreferenciasTemplate from "../../Preferencias/strategy/PreferenciasTemplate";
import { injectable } from "inversify";
import "reflect-metadata";
import { EWidgets } from "@/features/financas/views/Indicadores/@types/enums";

@injectable()
export default class PreferenciasPainelDeVendas extends PreferenciasTemplate<IFiltrosPainelDeVendas> {
  constructor() {
    super(EWidgets.VendasPanel);
  }

  obterSourceData(fieldName: string): number {
    const sourceDataItem = this.filtrosDoCard.find(
      (sourceDataId: IDataPreference) => sourceDataId.fieldName == fieldName
    );
    const souceDataValue = sourceDataItem?.fieldData || 1;

    return souceDataValue as number;
  }
}
